import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import axiosInstance from "api/axiosConfig";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axiosInstance.get("/auth/check");
        if (response.data.isAuthenticated) {
          // Récupérer les détails utilisateur si nécessaire
          const userDetails = await axiosInstance.get("/me");
          setUser(userDetails.data);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error("Erreur d'authentification :", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = async (credentials) => {
    const response = await axiosInstance.post("/login", credentials);
    setUser(response.data.user);
  };

  const logout = async () => {
    await axiosInstance.post("/logout");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
